import Vue from "vue";

import TicketChecker from "./TicketChecker.vue";

export function load() {
    const selector = "ticket-checker";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(TicketChecker, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
